import { getOrgUsers } from "@/api/requests/organization.js";

const loadUsers = async ({ commit, state }, { orgId, force }) => {
  if (!force && state.orgId === orgId && state.users.length > 0) return;
  commit("setLoading", true);
  try {
    const users = await getOrgUsers(orgId);
    commit("setUsers", { orgId, users });
  } catch {
    commit("setUsers", { orgId: null, users: [] });
  } finally {
    commit("setLoading", false);
  }
};

export default {
  namespaced: true,

  state: () => ({
    orgId: null,
    users: [],
    isLoading: false,
  }),

  mutations: {
    setUsers(state, { orgId, users }) {
      state.orgId = orgId;
      state.users = users;
    },
    setLoading(state, loading) {
      state.isLoading = loading;
    },
  },

  actions: {
    // Load org users, skips if already cached for this org
    load(ctx, orgId) {
      return loadUsers(ctx, { orgId, force: false });
    },

    // Force re-fetch (used on overview page navigation)
    reload(ctx, orgId) {
      return loadUsers(ctx, { orgId, force: true });
    },
  },

  getters: {
    getUserByClerkId: (state) => (clerkId) =>
      state.users.find((u) => u.clerkId === clerkId) || null,
    getUserById: (state) => (id) =>
      state.users.find((u) => u.id === id) || null,
  },
};
